import { createFileRoute } from '@tanstack/react-router'

import { TeamProfileRouteKernel } from '~/features/football-entities/route-modules'
import { teamProfileRouteModule } from '~/features/football-entities/route-options'

export const Route = createFileRoute('/_public/teams/$teamId')({
  ...teamProfileRouteModule,
  component: TeamProfileRoute,
})

function TeamProfileRoute() {
  return <TeamProfileRouteKernel route={Route} />
}
